// The HeySpa butterfly: four petals. With `open`, the petals spread once and close (the "all sent" moment).

const PETALS = [
  { k: 'ul', d: 'M4 2C30 2 47 19 47 52C21 52 4 35 4 2Z' },
  { k: 'ur', d: 'M96 6C96 32 79 47 53 47C53 21 70 6 96 6Z' },
  { k: 'll', d: 'M4 98C4 76 20 58 47 58C47 80 31 98 4 98Z' },
  { k: 'lr', d: 'M53 53C79 53 96 69 96 96C70 96 53 80 53 53Z' },
];

const LIGHT = { ul: '#0E2F46', ur: '#7DD3C7', ll: '#14B8A6', lr: '#14B8A6' };
const DARK = { ul: '#E6F7F3', ur: '#7DD3C7', ll: '#14B8A6', lr: '#14B8A6' };

export function Butterfly({ size = 32, dark = false, open = false }: { size?: number; dark?: boolean; open?: boolean }) {
  const c = dark ? DARK : LIGHT;
  return (
    <svg class={`bfly${open ? ' bfly-open' : ''}`} width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      {PETALS.map((p) => (
        <path key={p.k} class={`bfly-${p.k}`} d={p.d} fill={c[p.k as keyof typeof c]} />
      ))}
    </svg>
  );
}
